import { htcmdService } from 'js/services/htcmd.service';
import { useCookieSettingsSelector } from 'js/store/hooks';
import { pick } from 'ramda';
import { useEffect } from 'react';

export const useNativeCookieConsent = () => {
    const {
        groupsData,
        isInitialSetup
    } = useCookieSettingsSelector(pick([
        'groupsData',
        'isInitialSetup'
    ]));

    useEffect(() => {
        if (!htcmdService.isEnabled && !htcmdService.isWrapperEnabled) {
            return;
        }

        if (isInitialSetup) {
            return;
        }

        const {
            marketing,
            statistics
        } = groupsData ?? {};

        htcmdService.userConsent(marketing && statistics);
    }, [
        groupsData,
        isInitialSetup
    ]);
};
